export const fetchExtractTotalizer = () => ({
  type: 'FETCH_EXTRACT_TOTALIZERS',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v1/participants/me/extract'
    }
  }
})

export const fetchExtract = params => ({
  type: 'FETCH_EXTRACT',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v1/participants/me/extract',
      params
    }
  }
})

export const fetchCreditToExpire = periodId => ({
  type: 'FETCH_CREDIT_TO_EXPIRE',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/participants/me/toExpire/${periodId}`
    }
  }
})

export const fetchCampaignName = () => ({
  type: 'FETCH_CAMPAIGN_NAME',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v1/participants/me/fullBalance'
    }
  }
})

export default {
  fetchExtract,
  fetchExtractTotalizer,
  fetchCreditToExpire,
  fetchCampaignName
}



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/actions.js